import { TailSpin } from "react-loader-spinner";

export function Loading(props: { loading: boolean; className?: string }) {
	return (
		<TailSpin
			visible={props.loading}
			height="40"
			width="40"
			color="#666"
			ariaLabel="tail-spin-loading"
			radius="1"
			wrapperClass={`bg-gray-300 rounded-lg p-8 z-10 flex justify-center items-center mt-8 animate-pulse ${props.className ?? ""}`}
		/>
	);
}
